import en from "../locale/en.json";
import node_polyglot from "node-polyglot";
import no_nb from "../locale/no-nb.json";
import { printf, toText, split, isNullOrWhiteSpace } from "./fable_modules/fable-library-js.4.24.0/String.js";
import { item, tryPick } from "./fable_modules/fable-library-js.4.24.0/Array.js";
import { Tickets_Severity_FromId_Z524259A4, Tickets_Segment_FromId_Z524259A4, Tickets_TicketType_FromId_Z524259A4, Tickets_WarrantyType_FromId_Z524259A4, Tickets_UtilityClass_FromId_Z524259A4, Tickets_TicketStatus_FromId_Z524259A4, Tickets_Category_FromId_Z524259A4, Localization_Language, Localization_Language_FromString_Z721C83C5 } from "./Shared/Shared.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { Localization_$reflection } from "./Shared/ApiDataTypes.js";
import { testRedirect, extraCoders } from "./Promises.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "./fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "./fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "./fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { cons, ofArray, empty } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { defaultArgWith, some, unwrap, map, defaultArg } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { toString } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { unit_type, option_type, class_type, int32_type, record_type, lambda_type, string_type, obj_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { API_Localization_Root } from "./Shared/Urls.js";
import { fromString } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { uncurry2 } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { Record } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { nb, enGB } from "date-fns/locale";
import { intlFormat } from "date-fns";
import { toShortTimeString } from "./fable_modules/fable-library-js.4.24.0/Date.js";

export function getProvider(lang) {
    let phrases_1, phrases;
    if (lang.tag === 1) {
        return (phrases_1 = en, new node_polyglot({ phrases: phrases_1, locale: "en" }));
    }
    else {
        return (phrases = no_nb, new node_polyglot({ phrases: phrases, locale: "no" }));
    }
}

export function tryReadLocaleFromCookie() {
    if (isNullOrWhiteSpace(document.cookie)) {
        return undefined;
    }
    else {
        return tryPick((c) => {
            const y = split(c, ["="], undefined, 0);
            if (y.length <= 1) {
                return undefined;
            }
            else if (item(0, y) === "kundeweb.localization") {
                return Localization_Language_FromString_Z721C83C5(item(1, y));
            }
            else {
                return undefined;
            }
        }, split(document.cookie, ["; "], undefined, 0));
    }
}

export function fetchLocale() {
    let properties_2;
    let pr_2;
    let pr_1;
    const decoder = Auto_generateBoxedDecoder_Z6670B51(Localization_$reflection(), undefined, undefined);
    const data_1 = undefined;
    const caseStrategy_2 = undefined;
    const extra_2 = extraCoders;
    try {
        const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(API_Localization_Root, properties_3).then((_arg) => {
            let response_1, decoder_1_1;
            return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(Localization_$reflection(), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                let matchValue;
                return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
        }))));
        pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
    }
    catch (exn) {
        pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
    }
    pr_2 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
    return pr_2.then((_arg_2) => {
        if (_arg_2.tag === 1) {
            console.error(some("[Locale] Could not fetch localization: "), _arg_2.fields[0]);
            return new Localization_Language(0, []);
        }
        else {
            return Localization_Language_FromString_Z721C83C5(_arg_2.fields[0].Language);
        }
    });
}

/**
 * Try first to get locale from cookie, and if it isn't there, fetch from server
 */
export function tryGetLocale() {
    return defaultArgWith(map((a) => (Promise.resolve(a)), tryReadLocaleFromCookie()), fetchLocale);
}

export class DateFns_Match extends Record {
    constructor(ordinalNumber, era, quarter) {
        super();
        this.ordinalNumber = ordinalNumber;
        this.era = era;
        this.quarter = quarter;
    }
}

export function DateFns_Match_$reflection() {
    return record_type("Locale.DateFns.Match", [], DateFns_Match, () => [["ordinalNumber", lambda_type(string_type, string_type)], ["era", lambda_type(string_type, string_type)], ["quarter", lambda_type(string_type, string_type)]]);
}

export class DateFns_Options extends Record {
    constructor(weekStartsOn, firstWeekContainsDate) {
        super();
        this.weekStartsOn = (weekStartsOn | 0);
        this.firstWeekContainsDate = (firstWeekContainsDate | 0);
    }
}

export function DateFns_Options_$reflection() {
    return record_type("Locale.DateFns.Options", [], DateFns_Options, () => [["weekStartsOn", int32_type], ["firstWeekContainsDate", int32_type]]);
}

export class DateFns_Locale extends Record {
    constructor(code, formatDistance, formatLong, formatRelative, localize, match$0027, options) {
        super();
        this.code = code;
        this.formatDistance = formatDistance;
        this.formatLong = formatLong;
        this.formatRelative = formatRelative;
        this.localize = localize;
        this["match\'"] = match$0027;
        this.options = options;
    }
}

export function DateFns_Locale_$reflection() {
    return record_type("Locale.DateFns.Locale", [], DateFns_Locale, () => [["code", string_type], ["formatDistance", lambda_type(string_type, lambda_type(int32_type, lambda_type(obj_type, obj_type)))], ["formatLong", DateFns_FormatLong_$reflection()], ["formatRelative", lambda_type(string_type, lambda_type(option_type(class_type("System.DateTime")), lambda_type(option_type(class_type("System.DateTime")), lambda_type(obj_type, obj_type))))], ["localize", DateFns_Localize_$reflection()], ["match\'", DateFns_Match_$reflection()], ["options", DateFns_Options_$reflection()]]);
}

export class DateFns_FormatLong extends Record {
    constructor(date, time, dateTime) {
        super();
        this.date = date;
        this.time = time;
        this.dateTime = dateTime;
    }
}

export function DateFns_FormatLong_$reflection() {
    return record_type("Locale.DateFns.FormatLong", [], DateFns_FormatLong, () => [["date", lambda_type(unit_type, unit_type)], ["time", lambda_type(unit_type, unit_type)], ["dateTime", lambda_type(unit_type, unit_type)]]);
}

export class DateFns_Localize extends Record {
    constructor(ordinalNumber, era, quarter, month, day, dayPeriod) {
        super();
        this.ordinalNumber = ordinalNumber;
        this.era = era;
        this.quarter = quarter;
        this.month = month;
        this.day = day;
        this.dayPeriod = dayPeriod;
    }
}

export function DateFns_Localize_$reflection() {
    return record_type("Locale.DateFns.Localize", [], DateFns_Localize, () => [["ordinalNumber", lambda_type(int32_type, lambda_type(obj_type, int32_type))], ["era", lambda_type(int32_type, lambda_type(obj_type, int32_type))], ["quarter", lambda_type(int32_type, lambda_type(obj_type, int32_type))], ["month", lambda_type(int32_type, lambda_type(obj_type, obj_type))], ["day", lambda_type(int32_type, lambda_type(obj_type, obj_type))], ["dayPeriod", lambda_type(int32_type, lambda_type(obj_type, obj_type))]]);
}

export function getLocale(language) {
    if (language.tag === 1) {
        return enGB;
    }
    else {
        return nb;
    }
}

export class IntlFormat {
    constructor() {
    }
}

export function IntlFormat_$reflection() {
    return class_type("Locale.IntlFormat", undefined, IntlFormat);
}

export function IntlFormat_$ctor() {
    return new IntlFormat();
}

/**
 * Format a date based on localization
 */
export function toDateStr(locale, date) {
    return intlFormat(date, some({
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    }), some({
        locale: locale.code,
    }));
}

/**
 * Format a date based on localization
 */
export function toDateOnlyStr(locale, date) {
    return intlFormat(date, some({
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    }), some({
        locale: locale.code,
    }));
}

/**
 * Format DateTime to a pretty date and time string based on localization
 */
export function toDateAndTimeStr(locale, dateTime) {
    const date = toDateStr(locale, dateTime);
    const time = toShortTimeString(dateTime);
    return toText(printf("%s %s"))(date)(time);
}

export function Tickets_toLocalizedCategory(categoryId, locale) {
    const category = Tickets_Category_FromId_Z524259A4(categoryId);
    switch (category.tag) {
        case 1:
            return locale.t("Ticket.Category.Electrical");
        case 2:
            return locale.t("Ticket.Category.Mechanical");
        case 3:
            return locale.t("Ticket.Category.Oil");
        case 4:
            return locale.t("Ticket.Category.Structure");
        case 6:
            return locale.t("Ticket.Category.ServiceMaintenance");
        case 5:
            return locale.t("Ticket.Category.Other");
        default:
            return locale.t("Ticket.Category.Automation");
    }
}

export function Tickets_toLocalizedSegment(locale, segment) {
    switch (segment.tag) {
        case 1:
            return locale.t("Ticket.Segment.Industry");
        case 2:
            return locale.t("Ticket.Segment.Commercial");
        case 3:
            return locale.t("Ticket.Segment.Climate");
        default:
            return locale.t("Ticket.Segment.Marine");
    }
}

export function Tickets_severity(locale, severity) {
    switch (severity.tag) {
        case 1:
            return locale.t("Ticket.Severity.Urgent");
        case 2:
            return locale.t("Ticket.Severity.High");
        case 3:
            return locale.t("Ticket.Severity.Medium");
        case 4:
            return locale.t("Ticket.Severity.Low");
        case 5:
            return locale.t("Ticket.Severity.Info");
        default:
            return locale.t("Ticket.Severity.Critical");
    }
}

export function Tickets_toLocalizedType(locale, ticketType) {
    switch (ticketType.tag) {
        case 1:
            return locale.t("Ticket.TicketType.InspectionServiceRepair");
        case 2:
            return locale.t("Ticket.TicketType.UpdateAndModification");
        case 3:
            return locale.t("Ticket.TicketType.SpareParts");
        case 4:
            return locale.t("Ticket.TicketType.StartupAndCommissioning");
        case 5:
            return locale.t("Ticket.TicketType.Nonconformity");
        case 6:
            return locale.t("Ticket.TicketType.WarrantyRequest");
        case 7:
            return locale.t("Ticket.TicketType.InvoiceEconomy");
        case 8:
            return locale.t("Ticket.TicketType.Other");
        default:
            return locale.t("Ticket.TicketType.TechnicalSupport");
    }
}

export function Tickets_toLocalizedStatus(locale, statusId) {
    const status = Tickets_TicketStatus_FromId_Z524259A4(statusId);
    switch (status.tag) {
        case 1:
            return locale.t("Ticket.Status.Reopened");
        case 2:
            return locale.t("Ticket.Status.InProgress");
        case 3:
            return locale.t("Ticket.Status.Hold");
        case 4:
            return locale.t("Ticket.Status.Closed");
        default:
            return locale.t("Ticket.Status.AwaitingProcessing");
    }
}

export function Tickets_toLocalizedUtilityClass(utilityClassId, locale) {
    const utilityClass = Tickets_UtilityClass_FromId_Z524259A4(utilityClassId);
    switch (utilityClass.tag) {
        case 1:
            return locale.t("Ticket.UtilityClass.IceSystem");
        case 2:
            return locale.t("Ticket.UtilityClass.Cooler");
        case 3:
            return locale.t("Ticket.UtilityClass.Thawing");
        case 4:
            return locale.t("Ticket.UtilityClass.ControlSystem");
        case 5:
            return locale.t("Ticket.UtilityClass.StoreSolutions");
        case 6:
            return locale.t("Ticket.UtilityClass.Building");
        case 7:
            return locale.t("Ticket.UtilityClass.Processing");
        default:
            return locale.t("Ticket.UtilityClass.HeatPump");
    }
}

export function Tickets_toLocalizedWarrantyType(warrantyTypeId, locale) {
    const warrantyType = Tickets_WarrantyType_FromId_Z524259A4(warrantyTypeId);
    switch (warrantyType.tag) {
        case 1:
            return locale.t("Ticket.WarrantyType.RepairAndParts");
        case 2:
            return locale.t("Ticket.WarrantyType.Documentation");
        case 3:
            return locale.t("Ticket.WarrantyType.Repair");
        case 4:
            return locale.t("Ticket.WarrantyType.RemoteSupport");
        case 5:
            return locale.t("Ticket.WarrantyType.Inspection");
        default:
            return locale.t("Ticket.WarrantyType.ReplaceParts");
    }
}

/**
 * Uses the column ids defined in Shared to get the localized titles and texts for each union type
 */
export function Tickets_tryGetColumnTypeName(locale, columnId, value) {
    switch (columnId) {
        case 6:
            return Tickets_toLocalizedType(locale, Tickets_TicketType_FromId_Z524259A4(value));
        case 7:
            return Tickets_toLocalizedSegment(locale, Tickets_Segment_FromId_Z524259A4(value));
        case 8:
            return Tickets_toLocalizedCategory(value, locale);
        case 9:
            return Tickets_severity(locale, Tickets_Severity_FromId_Z524259A4(value));
        case 10:
            return Tickets_toLocalizedUtilityClass(value, locale);
        case 14:
            return Tickets_toLocalizedWarrantyType(value, locale);
        case 19:
            return Tickets_toLocalizedStatus(locale, value);
        default:
            return undefined;
    }
}

